import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.xray.dataset_viewer_runtime_v1');
import { OnInit, Input } from '@angular/core';

@Component({ standalone: false,
    selector: 'wiz-page-xray-dataset_viewer_runtime_v1',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.xray.dataset_viewer_runtime_v1/view.scss */
/* src/app/page.xray.dataset_viewer_runtime_v1/view.scss: no such file or directory */`],
})
export class PageXrayDataset_viewer_runtime_v1Component implements OnInit {
    @Input() title: any;

    public async ngOnInit() {
    }
}

export default PageXrayDataset_viewer_runtime_v1Component;